import { useEffect } from 'react';

export function ExternalRedirect() {
  useEffect(() => {
    window.location.href = 'https://kombu.team';
  }, []);

  return null;
}
